/**
 * Used to create `!important` css rules.
 *
 * It amends the returned value with a type assertion
 *  so that TypeScript does not complain about mismatches.
 */
export const important = (input) => `${input} !important`;
//# sourceMappingURL=important.js.map